import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import browser from "../../browser";
import {UserInputDisplayMode} from "../../redux/player/types";

type props = {
  displayMode: UserInputDisplayMode,
  isQuestion?: boolean,
}

export default function UserInputHelpText({displayMode, isQuestion}: props) {
  const {t} = useTranslation();
  const helpText = useMemo(() => {

    if (displayMode === UserInputDisplayMode.HINT_TEXT) {
      return ({
        "desktop": t("player.userInputAction.helpText.toSpeak.desktop")
      } as { [key: string]: string })[browser.getPlatformType(true)]
      ?? t("player.userInputAction.helpText.toSpeak.any")
    }

    if (displayMode === UserInputDisplayMode.SELECTABLE) {
      return ({
        "desktop": t("player.userInputAction.helpText.quiz.desktop")
      } as { [key: string]: string })[browser.getPlatformType(true)]
      ?? t("player.userInputAction.helpText.quiz.any")
    }

    if (displayMode === UserInputDisplayMode.TEXT_INPUT) {
      if (isQuestion) {
        return ({
          "desktop": t("player.userInputAction.helpText.textInputQuestion.desktop")
        } as { [key: string]: string })[browser.getPlatformType(true)]
        ?? t("player.userInputAction.helpText.textInputQuestion.any")
      }
      return ({
        "desktop": t("player.userInputAction.helpText.textInput.desktop")
      } as { [key: string]: string })[browser.getPlatformType(true)]
      ?? t("player.userInputAction.helpText.textInput.any")
    }

    if (displayMode === UserInputDisplayMode.TEXT_INPUT_SELECTABLE) {
      return ({
        "desktop": t("player.userInputAction.helpText.textInputSelectable.desktop")
      } as { [key: string]: string })[browser.getPlatformType(true)]
      ?? t("player.userInputAction.helpText.textInputSelectable.any")
    }


    return ({
      "desktop": t("player.userInputAction.helpText.default.desktop")
    } as { [key: string]: string })[browser.getPlatformType(true)]
    ?? t("player.userInputAction.helpText.default.any")
  }, [t, displayMode, isQuestion])

  return <>{helpText}</>
}
